import { ViewTTY } from "viewtty";

var terminal = new ViewTTY.Terminal({
  cols: 80,
  rows: 25,
  noFocus: true,
  noEvents: true,
});
terminal.open(document.getElementById("term"));
terminal.write("Loading ttyrec file");
terminal.showCursor();

// Then we create a player and hook its events to the terminal for display
var player = new ViewTTY.Player();
player.addListener(function (event: any) {
  if (event.type === "data") {
    terminal.write(event.data.data);
  }
  if (event.type === "end") {
    // loop
    setTimeout(() => {
      player.pause();
      player.rewind();
      terminal.reset();
      terminal.showCursor();
      player.play();
    }, 1000);
  }
});

// Now all we need to do is fetch the ttyrec output file as an ArrayBuffer
fetchArrayBuffer("/misc/gpt.py.ttyrec", function (arraybuffer: any) {
  terminal.reset();
  terminal.showCursor();
  try {
    // parse the response into chunks,
    var parser = new ViewTTY.Parser();
    var chunks = parser.parse(arraybuffer);

    // load the chunks into the player,
    player.load(chunks);

    // and now we're ready to go!
    player.play();
  } catch (e) {
    terminal.write(
      "\n\rERROR: unable to play the ttyrec file!\n\rYour browser may not be supported :(",
    );
  }
});

function fetchArrayBuffer(url: any, callback: any) {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url);
  xhr.responseType = "arraybuffer";
  xhr.onreadystatechange = function () {
    if (this.readyState === this.DONE) {
      if (this.status === 200) {
        callback(this.response);
      } else {
        terminal.write("\n\rERROR: failed to load the ttyrec file.");
      }
    } else {
      terminal.write(".");
    }
  };
  xhr.send();
}
